import styled from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import TYPO, { P1 } from 'styles/typography';

import ScrollToHeading from './ScrollToHeading';

const Paragraph = styled(P1)`
  margin: 0 0 18px;
  opacity: 1;

  ${BREAKPOINTS.small`
    margin-bottom: 15px;
  `}
`;

const List = styled.ul`
  margin-bottom: 18px;
`;

const ListItem = styled.li`
  ${TYPO.p1}
  margin-bottom: 7px;

  &:before {
    content: '●';
    margin-right: 5px;
    display: inline-block;
    font-size: 10px;
    color: inherit;
    vertical-align: bottom;
  }

  a {
    text-decoration: none;
  }

  ${BREAKPOINTS.small`
    margin-bottom: 3px;
  `}
`;

const Link = styled.a`
  ${TYPO.p1}
  font-weight: normal;
`;

export const components = {
  h2: ScrollToHeading,
  p: (props) => <Paragraph {...props} />,
  a: (props) => <Link {...props} />,
  ul: (props) => <List {...props} />,
  li: (props) => <ListItem {...props} />,
};
